export function shouldShowPrices() {
  return String(process.env.NEXT_PUBLIC_SHOW_PRICES || '').toLowerCase() === 'true';
}

